import store from '@/store/index.js'
let dic = store.state.dic;

export default function Configs(that) {

    const searchItems = [
        // {
        //     label: "角色名称",
        //     span: 8,
        //     model: "name",
        //     placeholder: '请输入角色名称'
        // },
        {
            label: "应用标识",
            span: 8,
            type: 'select',
            model: "type",
            placeholder: '请选择应用标识',
            options: [],
        },
    ]
    const tableColumns = [
        {
            label: "角色名称",
            prop: "name",
            align: "center",
            show: true
        },
        {
            label: "应用标识",
            prop: "typeName",
            align: "center",
            show: true
        },
        // {
        //     label: "角色分类",
        //     prop: "type",
        //     align: "center",
        //     show: true
        // },
        {
            label: "角色说明",
            prop: "description",
            align: "center",
            show: true
        },
        {
            label: "创建时间",
            prop: "createTime",
            align: "center",
            show: true
        },
        {
            label: "操作",
            name: "contr",
            align: "center",
            width: '260px',
            show: true
        }
    ]

    const formItems = [
        {
            label: "角色名称",
            placeholder: '请输入角色名称',
            span: 24,
            model: "name",
        },
        {
            label: "应用标识",
            span: 24,
            placeholder: '请选择应用标识',
            model: "type",
            type: 'select',
            options: [],
        },
        // {
        //     label: "角色分类",
        //     span: 24,
        //     placeholder: '请选择角色分类',
        //     model: "type",
        //     labelWidth: '150px',
        //     type: 'select'
        // },
        // {
        //     label: "查看权限",
        //     span: 24,
        //     placeholder: '请选择查看权限',
        //     model: "auth",
        //     labelWidth: '150px',
        // },
        {
            label: "角色说明",
            span: 24,
            placeholder: '请输入角色说明',
            model: "description",
            type: 'textarea'
        },

    ]
    const formRules = {
        name: [{
            required: true,
            message: "请输入角色名称",
            trigger: "blur"
        }],
        type: [{
            required: true,
            message: "请选择应用标识",
            trigger: "change"
        }],
    }
    return {
        formItems,
        formRules,
        tableColumns,
        searchItems
    }
}